"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toWireHistoryInfo = exports.toBankCardInfo = void 0;
const types_1 = require("./types");
function toBankCardInfo(item) {
    let tempBankNumber = "";
    let tempBankCode = "";
    let tempBankType = types_1.BankType.SWIFT;
    if (item.bank_account_iban.length > 0) {
        tempBankNumber = item.bank_account_iban;
        tempBankCode = item.bank_account_iban;
        tempBankType = types_1.BankType.IBAN;
    }
    if (item.bank_account_other.account_number.length > 0) {
        tempBankNumber = item.bank_account_other.account_number;
        tempBankCode = item.bank_account_other.swift_bic;
        tempBankType = types_1.BankType.SWIFT;
    }
    if (item.bank_account_us.account_number.length > 0) {
        tempBankNumber = item.bank_account_us.account_number;
        tempBankCode = item.bank_account_us.routing_number;
        tempBankType = types_1.BankType.ABA;
    }
    let tempBankName = item.bank_address.bank_name;
    if (item.bank_address.line1.length > 0) {
        tempBankName += item.bank_address.line1;
    }
    if (item.bank_address.line2.length > 0) {
        tempBankName += item.bank_address.line2;
    }
    return {
        bankId: item.bank_id,
        bankNumber: tempBankNumber,
        bankName: tempBankName,
        bankType: tempBankType,
        bankCode: tempBankCode,
        bankStatus: item.bank_status,
        reason: item.reason,
        trackingRef: item.tracking_ref,
        bankActivated: item.bank_activated,
        billingDetails: {
            name: item.billing_details.name,
            city: item.billing_details.city,
            country: item.billing_details.country,
            line1: item.billing_details.line1,
            line2: item.billing_details.line2,
            district: item.billing_details.district,
            postalCode: item.billing_details.postal_code,
        },
        bankAddress: {
            bankName: item.bank_address.bank_name,
            city: item.bank_address.city,
            country: item.bank_address.country,
            line1: item.bank_address.line1,
            line2: item.bank_address.line2,
            district: item.bank_address.district,
        },
        beneficiary: {
            name: item.beneficiary.name,
            address1: item.beneficiary.address1,
            address2: item.beneficiary.address2,
        },
        beneficiaryBank: {
            name: item.beneficiary_bank.name,
            swiftCode: item.beneficiary_bank.swift_code,
            accountNumber: item.beneficiary_bank.account_number,
            routingNumber: item.beneficiary_bank.routing_number,
            address: item.beneficiary_bank.address,
            city: item.beneficiary_bank.city,
            postalCode: item.beneficiary_bank.postal_code,
            country: item.beneficiary_bank.country,
        },
    };
}
exports.toBankCardInfo = toBankCardInfo;
function toWireHistoryInfo(item) {
    return {
        amount: item.amount,
        approvalReason: item.approval_reason,
        bank: toBankCardInfo(item.bank),
        createTime: item.create_time,
        fee: item.fee,
        note: item.note,
        trackingRef: item.tracking_ref,
        txId: item.tx_id,
        txStatus: item.tx_status,
        txType: item.tx_type,
        updateTime: item.update_time,
    };
}
exports.toWireHistoryInfo = toWireHistoryInfo;
//# sourceMappingURL=transform.js.map